import { FullWidthSection } from "../../@components/ReusableComponents/FullWidthSection";
import { SupplierDemandConstantsForm } from "../../@components/AiToolkit/SupplierDemand/SupplierDemandConstantsForm";
import theme from "../../theme";

export function SupplierDemandConstants() {
  return (
    <FullWidthSection
      sx={{
        background: theme.palette.linearGradient.gradientMain,
      }}
    >
      <SupplierDemandConstantsForm />
    </FullWidthSection>
  );
}
